module.exports = __webpack_public_path__ + "static/media/diktat-10.41f490d9.mp3";